import { hasAnyPermissions, hasAllPermissions } from 'src/utils/permissions';
import { useAuth } from 'src/contexts/JWTContext';

const usePermissions = requiredPermissions => {
  const { permissions: userPermissions } = useAuth();

  return {
    hasAny: hasAnyPermissions(userPermissions, requiredPermissions),
    hasAll: hasAllPermissions(userPermissions, requiredPermissions),
  };
};

export default usePermissions;
